import React from 'react';
import styled from '@emotion/styled';
import { Colors } from '@zapier/design-system';
import { mediaQueries } from 'components/mediaQueries';

type Props = {
  title: string;
};

export const TitleBanner = ({ title }: Props) => {
  return (
    <Outer>
      <Wrapper>
        <Title>{title}</Title>
      </Wrapper>
    </Outer>
  );
};

const Outer = styled.div`
  display: none;
  ${mediaQueries.tablet} {
    background-color: ${Colors.white};
    border-bottom: 1px solid ${Colors.grey200};
    display: grid;
    justify-items: center;
    left: 0;
    padding: 24px 20px;
    position: fixed;
    top: 51px; // positioned down 51px to account for the 50px SecondaryNavigation
    width: 100%;
    z-index: 40;
  }
  ${mediaQueries.desktop} {
    padding: 17px 40px 24px 40px;
  }
`;

const Wrapper = styled.div`
  max-width: 1200px;
  width: 100%;
`;

const Title = styled.p`
  color: ${Colors.grey900};
  font-weight: 600;
  font-size: 14px;
  line-height: 150%;
`;
